<template>
  <div class="component">
    <div class="component-title">发票费用</div>
    <table>
      <tbody>
        <tr style="height: 64px;">
          <td width="23%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">电子普票</td>
          <td width="77%" style="font-size: 12px;color: #EC892E;" :style="{color: Number(carAttributeFeeConfig.vatElectronicScale) ? '#3D3833' : '#EC892E'}">{{ Number(carAttributeFeeConfig.vatElectronicScale) ? `加收${carAttributeFeeConfig.vatElectronicScale*100}%的电票费用`: "免费" }}</td>
        </tr>
        <tr style="height: 64px;">
          <td width="23%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">增值税专票</td>
          <td width="77%" style="font-size: 12px;" :style="{color: Number(carAttributeFeeConfig.vatSpecialScale) ? '#3D3833' : '#EC892E'}">{{ Number(carAttributeFeeConfig.vatSpecialScale) ? `加收${carAttributeFeeConfig.vatSpecialScale*100}%的专票费用`: "免费" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name:"InvoiceFee",
  props:["carAttributeFeeConfig"],

}
</script>

<style scoped lang="scss">
  table,
  th,
  td {
    border: 1px solid #C9C2BB;
  }

  table {
    width: 100%;
    margin: 0 auto;
    display: table;
    border-spacing: 0;
    border-radius: 4px;
    overflow: hidden;
  }
  th,
  td {
    border-top-width: 0;
    border-left-width: 0;
    text-align: center;
  }

  th:last-child,
  td:last-child {
    border-right-width: 0;
  }

  tr:last-child td {
    border-bottom-width: 0;
  }

  td tr td{
    border-top: 1px solid #C9C2BB;
  }
  td tr:first-child td {
    border-top: 0;
    border-bottom: 0;
  }
  table tbody > tr > td:first-child {
    background-color: #F8F8F8;
  }
</style>